export default __webpack_public_path__ + "static/media/heraldofxotli_white_icon.7685a547.png";